import { render, staticRenderFns } from "./ModalConnectsInvite.vue?vue&type=template&id=118b8cbe&scoped=true"
import script from "./ModalConnectsInvite.vue?vue&type=script&lang=js"
export * from "./ModalConnectsInvite.vue?vue&type=script&lang=js"
import style0 from "./ModalConnectsInvite.vue?vue&type=style&index=0&id=118b8cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b8cbe",
  null
  
)

export default component.exports